import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import campraImg from "../../Img/CamptraLogoBg.png";
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../utils/config";

const Otp = () => {
  const [otpFields, setOTPFields] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [campraImg, setCampraImg] = useState(localStorage.getItem("logoImg"));
  const inputRefs = useRef([
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
  ]);

  const handleInputChange = (index, value) => {
    const newOTPFields = [...otpFields];
    newOTPFields[index] = value;
    setOTPFields(newOTPFields);

    // Move focus to the next input field
    if (value !== "" && index < otpFields.length - 1) {
      inputRefs.current[index + 1].current.focus();
    }
  };

  // Handle paste event across all input fields
  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData
      .getData("text")
      .slice(0, otpFields.length); // Ensure max 6 digits are pasted
    const newOTPFields = [...otpFields];

    pasteData.split("").forEach((value, index) => {
      newOTPFields[index] = value;
      inputRefs.current[index].current.value = value; // Directly set the value in the corresponding input
    });

    setOTPFields(newOTPFields);
    // Focus on the last filled input field
    inputRefs.current[pasteData.length - 1]?.current?.focus();
  };

  const handleWheel = (e) => {
    e.preventDefault(); // Prevent scrolling with the mouse wheel
  };

  const navigate = useNavigate();

  const userTagFetch = async (id, bearerToken) => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/user-details/${id}`, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log(response.data);
        if (
          response.data.hasOwnProperty("user-tags") &&
          response.data["user-tags"] !== ""
        ) {
          let tagIds = response.data["user-tags"];
          localStorage.setItem("tags", JSON.stringify(tagIds));
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  };

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    const isEmpty = otpFields.some((field) => field === "");
    if (isEmpty) {
      setError("Please fill in all OTP fields");
    } else {
      let digits = otpFields;
      let combinedNumber = parseInt(digits.join(""), 10);
      let verifyOtp = {
        user_email: localStorage.getItem("userEmail"),
        user_otp: combinedNumber,
        flag: true,
      };

      axios
        .post(`${API_BASE_URL}/wp-json/wp/v2/verifyotp`, verifyOtp, {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        })
        .then((response) => {
          console.log("otpres: ", response.data);
          if (response.data.status === 200) {
            toast.success(response.data.message);
            localStorage.setItem("jwt_token", response.data.tokens);
            localStorage.setItem("roles", response.data.current_user.roles[0]);
            localStorage.setItem(
              "display_name",
              response.data.current_user.data.display_name
            );
            localStorage.setItem(
              "current_user_Id",
              response.data.current_user.ID
            );

            if (response.data.current_user.roles[0] === "subscriber") {
              userTagFetch(response.data.current_user.ID, response.data.tokens);
            }

            let sessionId = Math.floor(Math.random() * 100000);
            sessionStorage.setItem("sessionId", sessionId);
            // window.location.reload();
            window.KR("init", {
              apiBase:
                (window.location.origin.includes("localhost")
                  ? "http://localhost:3060"
                  : window.location.origin + "/backend_cosmos") +
                "/widget/commonScript",
              displayName: localStorage.getItem("display_name"),
              userEmail: localStorage.getItem("userEmail"),
            });
            navigate("/default-page");
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          console.error("POST Error:", error);
        });
    }
  };

  useEffect(() => {
    axios.get(`${API_BASE_URL}/wp-json/custom/v1/image`).then((res) => {
      localStorage.setItem("logoImg", res.data);
      setCampraImg(res.data);
    });
  }, [campraImg]);

  useEffect(() => {
    let token = localStorage.getItem("jwt_token");
    if (token) {
      navigate("/default-page");
    }
  }, []);

  return (
    <div className="" style={{ height: "95vh" }}>
      <div className="row g-0">
        <div className="col-lg-3 col-md-3 col-sm-1"></div>
        <div className="col-lg-6 col-md-8 col-sm-10  ">
          <div className="d-flex flex-column align-items-center mt-5 pt-5 ">
            <div className="text-center  me-4 px-5 mb-3">
              <img className="w-50" src={campraImg} alt="" />
            </div>
            <h3 className="fw-bold text-center">
              Welcome To Knowledge Repository
            </h3>
            <h3
              className="fw-bold text-center mt-2"
              style={{ color: "#092360" }}
            >
              User Login
            </h3>
            <p
              className="mb-0"
              style={{
                fontSize: "1.2rem",
                color: "#092360",
                fontWeight: "200",
              }}
            >
              Please Enter the six digit code.
            </p>
            <form
              onSubmit={handleVerifyOTP}
              className="form_get_otp entercode enterOtpInput"
            >
              <div className="otp-input" onPaste={handlePaste}>
                {otpFields.map((field, index) => (
                  <input
                    id="exampleInputEmail1"
                    key={index}
                    type="text"
                    maxLength="1"
                    value={field}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                    className={error ? "input-error-otp" : ""}
                    ref={inputRefs.current[index]}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onWheel={handleWheel}
                  />
                ))}
              </div>
              {error && <p className="error">{error}</p>}
              <div className="otp-query">
                <Link to="/" className="otp-query email-change">
                  Change Email
                </Link>
              </div>
              <div className="text-center pt-4">
                <button
                  style={{ background: "#092360", color: "white" }}
                  type="submit"
                  className="btn rounded-pill m-0 p-2 px-4 fw-bold"
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-1"></div>
      </div>
    </div>
  );
};

export default Otp;
